import { useForm, useFormContext } from 'react-hook-form'

export default (formSetup?: Record<string, any>) => {
  const context = useFormContext()
  const locals = useForm(formSetup)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return context || locals
}
